// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"649":"cabca009","889":"85cc790b"}[chunkId] + ".chunk.js";
};